import { Component, OnInit, Input, OnDestroy, ComponentFactoryResolver, ViewContainerRef, ViewChild, ElementRef, ComponentRef } from '@angular/core';
import { isEmptyObject } from 'jquery';
import { GisNhipMapComponent } from 'src/app/main/shared/gis-nhip-map/gis-nhip-map.component';
import { UtilsService } from 'src/app/utils/utils.service';
import { NhipHomeDataService } from '../nhip-home-data.service';
// import { NhipHomeMapService } from '../nhip-home-map/nhip-home-map.service';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { NhipHomePdfComponent } from '../nhip-home-pdf/nhip-home-pdf.component';
import * as domtoimage from 'src/assets/js/maplibs/print/dom-to-image.js'
import { NhipHomeMapService } from '../nhip-home-map/nhip-home-map.service';
import { isNullOrUndefined } from 'util';
import { CYCLONE_GRADE_INTENSITY_MAPPING, CYCLONE_INTENSITY_MAPPING, CycloneColumnConfig, EarthquakeColumnConfig } from '../nhip-home-map/nhip-home-map-constants';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-nhip-home-infobox',
  templateUrl: './nhip-home-infobox.component.html',
  styleUrls: ['./nhip-home-infobox.component.scss']
})
export class NhipHomeInfoboxComponent implements OnInit, OnDestroy {

  pointLocationInfo: {
    stateName?: string;
    districtName?: string;
    blockName?: string;
  } | null = null;

  isLoadingPointData: boolean = false;
  selectedLat: number | null = null;
  selectedLng: number | null = null;
  // Location and facilities load in separate requests after a point click; the PDF
  // download stays disabled until both return so the report isn't missing them.
  isLoadingPointLocation: boolean = false;
  isLoadingFacilities: boolean = false;
  isPointQuery: boolean = false;
  pointHazardData: any = null;
  nearestEarthquakePoint: any = null;
  nearestCyclone: any = null;
  pointEarthquakeZone: number = 0;
  pointWindZone: number = 0;
  nearestSchool: any = null;
  nearestHealthcare: any = null;

  // @ViewChild('pdfContent', { static: false })
  @ViewChild('pdfContainer', {
    read: ViewContainerRef,
    static: false
  })
  container: ViewContainerRef;
  pdfContent: ElementRef;
  sortedValidFaultLines: any[] = [];
  nullFaultLines: any[] = [];
  validFaultLines: any[] = [];
  earthquakeCount: number = 0;
  seismicZone: string = 'Zone I & II';
  zonePercentage: number = 0;
  largestMagnitude: number = 0;
  averageDepth: number = 0;
  recentEarthquake: any = null;
  earthquakeData: any[] = [];
  showAllEarthquakes: boolean = false;
  seismicZones: { zone: number; percentage: number }[] = [];
  cycloneData: any[] = [];
  showAllCyclones: boolean = false;
  groupedEarthquakes: { year: number; data: any[] }[] = [];
  cycloneStats = {
    totalEvents: 0,
    uniqueCyclones: 0,
    recentCyclone: null
  };

  headerConfig = {
    title: 'Area Hazard Query',
    location: 'North Mandal',
    coords: '12.8864° N, 79.9555° E'
  };

  seismicConfig = {
    label: 'Earthquake Seismic Zone',
    zone: '',
    risk: '',
    riskClass: ''
  };

  cycloneSeismicZones: { zone: number; percentage: number; intersectAreaSqkm?: number }[] = [];
  cycloneZonePercentage: number = 0;
  cycloneSeismicConfig = {
    label: 'Wind Zone',
    zone: '',
    risk: '',
    riskClass: ''
  };
  faultLines: any[] = [];
  nearestFaultLine: any = null;
  faultLineCount: number = 0;

  faultConfig = {
    title: 'Nearest Fault Line',
    name: 'No fault line data available',
    distance: '',
    type: '',
    length: '',
    lastEvent: '',
    note: ''
  };
  cycloneGradeColors: { [key: string]: string } = {
      L: '#FFFFFF',
    D: '#66BB6A',
    DD: '#26C6DA',
    CS: '#1E88E5',
    SCS: '#FFA726',
    VSCS: '#FF7043',
    ESCS: '#E53935',
    ESC: '#E53935',
    SuCS: '#B71C1C'
  };


  hazardsConfig = {
    title: 'Hazards',
    subtitle: '(Last 10 Years)',
    yearRange: '2016-2026',
    items: [
      // { label: 'Earthquakes', count: 0 as number | null, icon: '⚡', class: 'earthquake' },
      // { label: 'Cyclones', count: null as number | null, icon: '🌪️', class: 'cyclone' },
      // { label: 'Floods', count: 0, icon: '🌊', class: 'flood' }
    ]
  };
  allHazardItems = [
      { label: 'Earthquakes', count: 0 as number | null, icon: '⚡', class: 'earthquake' },
      { label: 'Cyclones', count: null as number | null, icon: '🌪️', class: 'cyclone' },
      // { label: 'Floods', count: 0, icon: '🌊', class: 'flood' }
    ]
  showAlertInfo: boolean = false;
  selectedDistrictUUID: string = '';
  selectedStateUUID: string = '';
  selectedCountryUUID: string = '';
  selectedLocType: 'DISTRICT' | 'STATE' | 'COUNTRY' | '' = '';
  selectedTimeRange: string = 'Last 10 Years';
  mapImage: any;
  processedCycloneDataForPdf: any[] = [];
  earthquakeDataForPdf: any[] = [];
  facilities: any[] = [];
  cycloneIntensityMapping: any = CYCLONE_INTENSITY_MAPPING
  cyclonegradeToIntensityMap: any = CYCLONE_GRADE_INTENSITY_MAPPING
  subscriptions: any[] = [];
  queryParams: any = {};

  // Location breadcrumb (India > State > District), moved here from the navbar.
  // The route query params (location / locType) remain the single source of truth for the selected location.
  selectedLocation: any = '';
  selectedLocForParams: any;
  locationList: any = [];
  locationHie = ['COUNTRY', 'STATE', 'DISTRICT'];
  stateSearchText: string = '';
  districtSearchText: string = '';
  showStateDropdown: boolean = false;
  showDistrictDropdown: boolean = false;
  filteredStateList: any[] = [];
  filteredDistrictList: any[] = [];
  earthquakeTableConfiguration: any;
  earthquakeTableData: any[] = [];

  cycloneTableConfiguration: any;
  cycloneTableData: any[] = [];


  // Per-API subscriptions — unsubscribed before each new request to prevent stale data accumulation
  private earthquakeSub: Subscription | null = null;
  private cycloneHazardSub: Subscription | null = null;
  private cycloneGradeSub: Subscription | null = null;
  private cycloneZoneSub: Subscription | null = null;
  private faultLineSub: Subscription | null = null;
  private earthquakeZoneSub: Subscription | null = null;
  constructor(
    public gisMapComp: GisNhipMapComponent,
    private utils: UtilsService,
    private nhipDataSrv: NhipHomeDataService,
    private resolver: ComponentFactoryResolver,
    private nhipMapSrv: NhipHomeMapService,
    public route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    const mapClickSubscription = this.utils.setViewForNHIPAlert.subscribe(info => {
      // Location Info view is point-query only; area selections must not trigger area hazard APIs
      if (!isEmptyObject(info) && !this.isLocationInfoView()) {
        this.showAlertInfo = true;
        this.isPointQuery = false; // area selection always switches away from point query mode
        this.headerConfig.location = info.locName;
        this.headerConfig.coords = info.lat + '° N, ' + info.lng + '° E';
        const infoLocType = (info.locType || '').toString().toUpperCase();
        if (infoLocType === 'COUNTRY' || info.countryUUID) {
          this.selectedCountryUUID = info.countryUUID || info.pUUID;
          this.selectedStateUUID = '';
          this.selectedDistrictUUID = '';
          this.selectedLocType = 'COUNTRY';
        } else if (infoLocType === 'STATE' || info.stateUUID) {
          this.selectedStateUUID = info.stateUUID;
          this.selectedDistrictUUID = '';
          this.selectedLocType = 'STATE';
        } else if (infoLocType === 'DISTRICT' || info.districtUUID) {
          this.selectedDistrictUUID = info.districtUUID;
          this.selectedStateUUID = '';
          this.selectedLocType = 'DISTRICT';
        }

        if (this.getSelectedLocUUID()) {
          this.getHazardData();
        }
      } else {
        // this.showAlertInfo = false;
        // this.selectedCountryUUID = '';
        // this.selectedDistrictUUID = '';
        // this.selectedStateUUID = '';
        // this.selectedLocType = '';
        // this.closePanel()
      }
    });
    const pointHazardSubscription = this.utils.pointHazardData.subscribe(info => {
      if (info) {
        this.showPointHazardInfo(info.latitude, info.longitude, info.data);
      }
    });

    const timeRangeSubscription = this.utils.nhipTimeRangeChange.subscribe(timeRange => {
      if (timeRange) {
        this.selectedTimeRange = timeRange;
        // console.log('Time range updated to:', timeRange);
        if (this.getSelectedLocUUID() && !this.isLocationInfoView()) {
          this.getHazardData();
        }
      }
    });

    const paramsSubscription = this.route.queryParams.subscribe((params: Params) => {
      this.queryParams = { params: params };
      const p = this.queryParams.params;
      if (!isNullOrUndefined(p) && !isEmptyObject(p)) {
        // Reset selectedLocation to show placeholder when at COUNTRY or STATE level
        if (p.locType === 'COUNTRY' || p.locType === 'STATE') {
          this.selectedLocation = '';
        }
        if (!this.isLocationOnlyMode()) {
          this.getLocationList();
        }
        if (p.hazardView == 'locationInfo') {
          this.closePanel()
          this.isPointQuery = true
          this.showAlertInfo = false
        } else if (p.pUUID && p.locType === 'COUNTRY') {
          this.showAlertInfo = true;
          this.selectedCountryUUID = p.pUUID;
          this.selectedLocType = 'COUNTRY';
          this.headerConfig.location = p.locName || 'India';
          this.headerConfig.coords = '';
          this.getHazardData();
        }
      }
    });

    const infoboxResetSub = this.utils.nhipInfoboxReset.subscribe(() => {
      // In Location Info view, go back to the initial empty state ("Click on the map...")
      // instead of an empty area card with only the download/close buttons.
      const isLocationInfo = this.isLocationInfoView();
      this.isPointQuery = isLocationInfo;
      this.showAlertInfo = !isLocationInfo;
      this.headerConfig.title = 'Area Hazard Query';
      this.headerConfig.location = 'India';
      this.headerConfig.coords = '';

      // Comprehensive Reset - Clear all hazard data
      this.hazardsConfig.items = [];
      this.earthquakeCount = 0;
      this.earthquakeData = [];
      this.seismicZones = [];
      this.groupedEarthquakes = [];
      this.earthquakeTableData = [];

      this.cycloneStats.totalEvents = 0;
      this.cycloneStats.uniqueCyclones = 0;
      this.cycloneStats.recentCyclone = null;
      this.cycloneData = [];
      this.processedCycloneData = [];
      this.cycloneTableData = [];
      this.cycloneSeismicZones = [];

      this.nearestFaultLine = null;
      this.faultLines = [];
      this.faultLineCount = 0;
      this.sortedValidFaultLines = [];
      this.nullFaultLines = [];

      this.facilities = [];
      this.pointLocationInfo = null;
      this.nearestEarthquakePoint = null;
      this.nearestCyclone = null;
      this.pointHazardData = null;
      this.isLoadingPointData = false;

      if (!this.gisMapComp.dataTabToggleVal) {
        this.gisMapComp.dataTabToggle();
      }
    });

    this.subscriptions.push(mapClickSubscription)
    this.subscriptions.push(pointHazardSubscription)
    this.subscriptions.push(timeRangeSubscription)
    this.subscriptions.push(paramsSubscription)
    this.subscriptions.push(infoboxResetSub);
    // this.gisMapComp.map.whenReady(() => {
    // setTimeout(async () => {
    // this.mapImage = await this.captureLeafletCanvas();
    // console.log("mapimage::", this.mapImage);
    // }, 1500);
    // })
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    // Clean up per-API subscriptions
    [this.earthquakeSub, this.cycloneHazardSub, this.cycloneGradeSub, this.cycloneZoneSub, this.faultLineSub, this.earthquakeZoneSub]
      .forEach(sub => { if (sub) sub.unsubscribe(); });
  }

  // ---- Location breadcrumb ----
  isLocationOnlyMode(): boolean {
    return this.route.snapshot.queryParams['locationOnly'] === 'true';
  }

  // Snapshot (not this.queryParams) so it is already current when other subscribers fire on a route change
  isLocationInfoView(): boolean {
    return this.route.snapshot.queryParams['hazardView'] === 'locationInfo';
  }

  showBreadcrumb(): boolean {
    return !!this.queryParams.params && !this.isLocationOnlyMode() && this.queryParams.params.hazardView !== 'locationInfo';
  }

  getLocationList() {
    if (this.isLocationOnlyMode()) return;

    this.locationList = [];
    let postData = {
      "sDate": "20241009",
      "eDate": "20241009",
      "pUUID": this.queryParams.params['pUUID'],
      "pType": this.queryParams.params['locType'],
      "format": "DAILY",
      "cType": this.locationHie[this.locationHie.indexOf(this.queryParams.params['locType']) + 1],
      "pEUUID": this.queryParams.params['pEUUID'],
      "classification": ["ACTUAL"],
      "src": "NHP",
      "aggr": "SUM",
      "includeAllLoc": true
    }

    this.nhipDataSrv.getLocationList(postData).subscribe(response => {
      if (Object.keys(response).length > 0) {
        response.forEach((item) => {
          if (item.md && item.md.ln && item.nm != 'TOTAL') {
            item.nm = this.utils.titleCase(item.nm);
            this.locationList.push(item);
          }
        });
        this.locationList.sort((a, b) => a.nm.localeCompare(b.nm));
        this.filteredStateList = [...this.locationList];
        this.filteredDistrictList = [...this.locationList];
      } else {
        this.filteredStateList = [];
        this.filteredDistrictList = [];
      }
    }, err => {
      this.locationList = [];
      this.filteredStateList = [];
      this.filteredDistrictList = [];
    });
  }

  onLocationChange() {
    if (this.isLocationOnlyMode()) return;

    if (this.queryParams.params.locType == 'STATE') {
      // Handle DISTRICT selection
      let selectedUID = this.selectedLocation.split('##')[1];
      let selectedLocationObj = this.locationList.find(
        (loc: any) => loc.uid === selectedUID
      );
      if (selectedLocationObj) {
        let obj = {
          locName: selectedLocationObj.nm,
          lat: selectedLocationObj.md.lt,
          lng: selectedLocationObj.md.lng,
          districtUUID: selectedLocationObj.uid,
          locType: 'DISTRICT'
        };
        localStorage.setItem('infoObj', JSON.stringify(obj))
        this.utils.setViewForNHIPAlert.next(obj);
        if (!this.gisMapComp.dataTabToggleVal) {
          this.gisMapComp.dataTabToggle()
        }
      }
    } else if (this.queryParams.params.locType == 'COUNTRY') {
      // Handle STATE selection
      let selectedUID = this.selectedLocation.split('##')[1];
      let selectedLocationObj = this.locationList.find(
        (loc: any) => loc.uid === selectedUID
      );
      if (selectedLocationObj) {
        let obj = {
          locName: selectedLocationObj.nm,
          lat: selectedLocationObj.md.lt,
          lng: selectedLocationObj.md.lng,
          stateUUID: selectedLocationObj.uid,
          locType: 'STATE'
        };
        localStorage.setItem('infoObj', JSON.stringify(obj))
        this.utils.setViewForNHIPAlert.next(obj);
        if (!this.gisMapComp.dataTabToggleVal) {
          this.gisMapComp.dataTabToggle()
        }
      }
    }
    let options: any = { ...this.queryParams.params }
    this.selectedLocForParams = this.selectedLocation
    options['location'] += '&' + this.selectedLocation
    options['locType'] = this.locationHie[this.locationHie.indexOf(this.queryParams.params.locType) + 1]
    options['locName'] = this.selectedLocForParams.split('##')[0]
    options['pUUID'] = this.selectedLocForParams.split('##')[1]
    this.gisMapComp.params['actionType'] = 'mapClick'
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  resetLocation() {
    if (this.isLocationOnlyMode()) return;

    this.selectedLocation = this.queryParams.params.location.split('&')[0];
    this.stateSearchText = '';
    this.districtSearchText = '';
    this.showStateDropdown = false;
    this.showDistrictDropdown = false;
    this.utils.setViewForNHIPAlert.next({});
    let options: any = { ...this.queryParams.params };
    this.selectedLocForParams = this.selectedLocation;
    options['location'] = this.selectedLocation;
    options['locType'] = this.locationHie[0];
    options['locName'] = this.selectedLocForParams.split('##')[0];
    options['pUUID'] = this.selectedLocForParams.split('##')[1];
    this.gisMapComp.params['actionType'] = 'mapClick';
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    });
  }

  navigateToState() {
    if (this.isLocationOnlyMode()) return;

    if (this.queryParams.params.locType === 'DISTRICT') {
      const locationParts = this.queryParams.params.location.split('&');

      if (locationParts.length >= 2) {
        const stateName = locationParts[1].split('##')[0];
        const stateUUID = locationParts[1].split('##')[1];

        this.selectedLocation = '';
        this.districtSearchText = '';
        this.showDistrictDropdown = false;
        let obj = {
          locType: 'STATE',
          stateUUID: stateUUID,
          locName: stateName,
          lat: this.gisMapComp.map.getCenter().lat,
          lng: this.gisMapComp.map.getCenter().lng
        };
        localStorage.setItem('infoObj', JSON.stringify(obj));
        this.utils.setViewForNHIPAlert.next(obj);

        if (!this.gisMapComp.dataTabToggleVal) {
          this.gisMapComp.dataTabToggle();
        }

        let options: any = { ...this.queryParams.params };
        options['location'] = locationParts[0] + '&' + locationParts[1];
        options['locType'] = 'STATE';
        options['locName'] = stateName;
        options['pUUID'] = stateUUID;
        this.gisMapComp.params['actionType'] = 'mapClick';
        this.router.navigate(['.'], {
          relativeTo: this.route,
          queryParams: options,
          queryParamsHandling: 'merge'
        });
      }
    }
  }

  getBreadcrumbParts(): string[] {
    if (!this.queryParams.params || !this.queryParams.params.location) {
      return [];
    }
    return this.queryParams.params.location.split('&');
  }

  getStateName(): string {
    const parts = this.getBreadcrumbParts();
    return parts.length >= 2 ? parts[1].split('##')[0] : '';
  }

  getDistrictName(): string {
    const parts = this.getBreadcrumbParts();
    return parts.length >= 3 ? parts[2].split('##')[0] : '';
  }

  filterStates() {
    if (!this.stateSearchText.trim()) {
      this.filteredStateList = [...this.locationList];
    } else {
      const searchTerm = this.stateSearchText.toLowerCase().trim();
      this.filteredStateList = this.locationList.filter(state =>
        state.nm.toLowerCase().includes(searchTerm)
      );
    }
    this.showStateDropdown = true;
  }

  filterDistricts() {
    if (!this.districtSearchText.trim()) {
      this.filteredDistrictList = [...this.locationList];
    } else {
      const searchTerm = this.districtSearchText.toLowerCase().trim();
      this.filteredDistrictList = this.locationList.filter(district =>
        district.nm.toLowerCase().includes(searchTerm)
      );
    }
    this.showDistrictDropdown = true;
  }

  selectState(location: any) {
    this.stateSearchText = location.nm;
    this.selectedLocation = location.nm + '##' + location.uid;
    this.showStateDropdown = false;
    this.onLocationChange();
  }

  selectDistrict(location: any) {
    this.districtSearchText = location.nm;
    this.selectedLocation = location.nm + '##' + location.uid;
    this.showDistrictDropdown = false;
    this.onLocationChange();
  }

  closeStateDropdown() {
    setTimeout(() => {
      this.showStateDropdown = false;
    }, 200);
  }

  closeDistrictDropdown() {
    setTimeout(() => {
      this.showDistrictDropdown = false;
    }, 200);
  }

  // closePanel() {
  //   if (this.gisMapComp.dataTabToggleVal) {
  //     this.gisMapComp.dataTabToggle();
  //   }
  // }
  // Override closePanel to reset point state
  // closePanel only toggles panel visibility.
  // Data is intentionally preserved so reopening via the 'i' icon shows the
  // last queried hazard details. New map clicks / area selections overwrite
  // the state naturally via showPointHazardInfo() / getHazardData().
  closePanel() {
    if (this.gisMapComp.dataTabToggleVal) {
      this.gisMapComp.dataTabToggle();
    }

    // Reset point query state
    // this.isPointQuery = false;
    // this.selectedLat = null;
    // this.selectedLng = null;
    // this.pointHazardData = null;
    // this.nearestEarthquakePoint = null;
    // this.nearestCyclone = null;
    // // this.showAlertInfo = false;
    // this.selectedCountryUUID = '';
    // this.selectedStateUUID = '';
    // this.selectedDistrictUUID = '';
    // this.selectedLocType = '';
    // this.pointLocationInfo = null;
    // this.facilities = []
  }

  getHazardData() {
    if (!this.getSelectedLocUUID()) {
      console.log('No location selected yet');
      return;
    }
    // Reset table
    // leftover cyclone/earthquake rows from the previous selection.
    this.showAllCyclones = false;
    this.showAllEarthquakes = false;
    this.cycloneTableData = [];
    this.processedCycloneData = [];
    this.earthquakeTableData = [];

    const { startYear, endYear } = this.getYearRange();
    const selectedLocUUID = this.getSelectedLocUUID();
    const locType = this.getSelectedLocTypeLower();
    this.updateHazardsConfig(this.queryParams['params']['hazardView'])

    let postData = {
      "pUUID": selectedLocUUID,
      "hazardType": "CYCLONE",
      "startTs": startYear.toString(),
      "endTs": endYear.toString(),
      "locType": locType

    };

    // console.log('Fetching hazard data with payload:', postData);

    if (this.cycloneHazardSub) {
      this.cycloneHazardSub.unsubscribe();
      this.cycloneHazardSub = null;
    }
    this.cycloneHazardSub = this.nhipDataSrv.getHazardData(postData).subscribe(response => {
      // console.log(response, "response getHazardData");

      const hazardData = Array.isArray(response) ? response : (response && response.data ? response.data : []);
      const summary = !Array.isArray(response) && response ? response.summary : null;

      if (!hazardData || hazardData.length === 0) {
        this.cycloneData = [];
        this.processedCycloneData = [];
        this.cycloneTableData = [];
        this.cycloneStats = { totalEvents: 0, uniqueCyclones: 0, recentCyclone: null };
        const cycloneItem:any = this.hazardsConfig.items.find(i => i.label === 'Cyclones');
        if (cycloneItem) {
          cycloneItem.count = 0;
          // console.log('[Cyclone Badge] API returned empty data → count set to 0');
        }
        this.hazardsConfig.subtitle = `(${this.selectedTimeRange})`;
        return;
      }
      const filteredData = this.filterDataByTimeRange(hazardData);

      this.cycloneData = filteredData;
      this.calculateCycloneStats();
      this.getCycloneGradeWiseData();



      const cycloneItem:any = this.hazardsConfig.items.find(i => i.label === 'Cyclones');
      if (cycloneItem) {
        cycloneItem.count = this.cycloneStats.totalEvents;
      }

      this.hazardsConfig.subtitle = `(${this.selectedTimeRange})`;
    });

    this.getCycloneZoneData();
    this.getEarthquakeData();
    this.getFaultLineData();
  }

  updateHazardsConfig(view: string) {
    this.hazardsConfig.items = view === 'multiHazard' ? [...this.allHazardItems] : this.allHazardItems.filter(item => item.class === view);
  }

  getFaultLineData() {
    if (!this.getSelectedLocUUID()) {
      return;
    }

    const postData = {
      pUUID: this.getSelectedLocUUID(),
      hazardType: 'EarthQuake',
      "pType": this.getSelectedLocTypeUpper(),

    };

    if (this.faultLineSub) {
      this.faultLineSub.unsubscribe();
      this.faultLineSub = null;
    }
    this.faultLineSub = this.nhipDataSrv.getDistrictFaultline(postData).subscribe(
      (response: any) => {
        // console.log('Fault line response:', response);
        this.faultLines = response.faultLines || [];
        this.nearestFaultLine = response.nearestFaultLine;
        this.faultLineCount = response.faultLineCount || 0;
        const validFaults = this.faultLines.filter(fault => fault.faultName);
        const nullFaults = this.faultLines.filter(fault => !fault.faultName);
        this.sortedValidFaultLines = validFaults.sort((a, b) =>
          a.faultName.localeCompare(b.faultName)
        );

        this.nullFaultLines = nullFaults;

        this.updateFaultConfig();
      },
      error => {
        console.error('Error fetching fault line data:', error);
        this.resetFaultData();
      }
    );
  }

  updateFaultConfig() {
    this.faultConfig = {
      title: 'Nearest Fault Line',
      name: 'No fault line data available',
      distance: '',
      type: '',
      length: '',
      lastEvent: '',
      note: ''
    };

    if (this.nearestFaultLine && this.nearestFaultLine.faultName) {
      this.faultConfig.name = this.nearestFaultLine.faultName;

      if (this.nearestFaultLine.distanceKm) {
        this.faultConfig.distance = `${this.nearestFaultLine.distanceKm.toFixed(1)} km away`;
      }

      this.faultConfig.type = this.getFaultType(this.nearestFaultLine.faultName);
      this.faultConfig.length = this.getFaultLength(this.nearestFaultLine.faultName);
      this.faultConfig.note = `This fault line is ${this.nearestFaultLine.distanceKm ? this.nearestFaultLine.distanceKm.toFixed(1) : 'an unknown'} km from the selected area.`;
    }
  }
  getFaultType(faultName: string): string {
    const faultTypeMap: { [key: string]: string } = {
      'ISLAND BELT FAULT': 'Active Fault Zone',
      'KUTCH MAINLAND FAULT': 'Major Seismic Fault',
      'EASTERN GHATS MOBILE BELT': 'Ancient Fault Zone'
    };

    return faultTypeMap[faultName] || 'Seismic Fault Line';
  }

  getFaultLength(faultName: string): string {
    const faultLengthMap: { [key: string]: string } = {
      'ISLAND BELT FAULT': '350 km',
      'KUTCH MAINLAND FAULT': '300 km',
      'EASTERN GHATS MOBILE BELT': '1000 km'
    };

    return faultLengthMap[faultName] || 'Unknown length';
  }

  resetFaultData() {
    this.faultLines = [];
    this.nearestFaultLine = null;
    this.faultLineCount = 0;

    this.faultConfig = {
      title: 'Nearest Fault Line',
      name: 'No fault line data available',
      distance: '',
      type: '',
      length: '',
      lastEvent: '',
      note: ''
    };
  }
  getCycloneZoneData() {
    if (!this.getSelectedLocUUID()) {
      return;
    }
    const postData = {
      pUUID: this.getSelectedLocUUID(),
      hazardType: 'CYCLONE',
      locType: this.getSelectedLocTypeUpper()
    };
    // console.log('Fetching wind zone data for:', this.selectedLocType, 'with payload:', postData);
    let apiCall$;
    if (this.selectedLocType === 'STATE') {
      apiCall$ = this.nhipDataSrv.getStateWindZonePercentage(postData);
    } else {
      apiCall$ = this.nhipDataSrv.getCycloneZoneData(postData);
    }

    if (this.cycloneZoneSub) {
      this.cycloneZoneSub.unsubscribe();
      this.cycloneZoneSub = null;
    }
    this.cycloneZoneSub = apiCall$.subscribe(
      (res: any) => {
        // console.log('Wind zone response:', res);
        if (!res || !res.zones || res.zones.length === 0) {
          this.cycloneSeismicZones = [];
          this.cycloneZonePercentage = 0;
          this.cycloneSeismicConfig.zone = '';
          this.cycloneSeismicConfig.risk = '';
          this.cycloneSeismicConfig.riskClass = '';
          return;
        }
        // this.cycloneSeismicZones = res.zones;
        this.cycloneSeismicZones = res.zones.filter(z => z.percentage > 0);
        const validZones = this.cycloneSeismicZones.filter(
          z => z.zone !== 0 || z.percentage > 0
        );

        if (validZones.length === 0) {
          this.cycloneSeismicZones = [];
          this.cycloneSeismicConfig.zone = '';
          this.cycloneSeismicConfig.risk = '';
          this.cycloneSeismicConfig.riskClass = '';
          return;
        }

        const dominantZone = validZones.reduce((max, z) =>
          z.percentage > max.percentage ? z : max
        );

        this.cycloneZonePercentage = dominantZone.percentage;
        this.cycloneSeismicConfig.zone = `Zone ${dominantZone.zone}`;
        this.cycloneSeismicConfig.risk =
          this.getCycloneRiskByZone(dominantZone.zone);
        this.cycloneSeismicConfig.riskClass =
          this.getCycloneRiskClassByZone(dominantZone.zone);
      },
      error => {
        console.error('Error fetching wind zone data:', error);
        this.cycloneSeismicZones = [];
        this.cycloneSeismicConfig.zone = '';
        this.cycloneSeismicConfig.risk = '';
        this.cycloneSeismicConfig.riskClass = '';
      }
    );
  }

  getCycloneRiskByZone(zone: number): string {
    const riskMap: { [key: number]: string } = {
      0: 'No Risk',
      1: 'Very Low Risk',
      2: 'Low Risk',
      3: 'Moderate Risk',
      4: 'High Risk',
      5: 'Very High Risk',
      6: 'Extreme Risk'
    };
    return riskMap[zone] || 'Unknown Risk';
  }

  getCycloneRiskClassByZone(zone: number): string {
    const classMap: { [key: number]: string } = {
      0: 'none',
      1: 'very-low',
      2: 'low',
      3: 'moderate',
      4: 'high',
      5: 'very-high',
      6: 'extreme'
    };
    return classMap[zone] || 'unknown';
  }

  // getEarthquakeData() {
  //   if (!this.getSelectedLocUUID()) {
  //     return;
  //   }
  //   const { startTs, endTs } = this.getEarthquakeEpochRange();
  //   const postData = {
  //     pUUID: this.getSelectedLocUUID(),
  //     hazardType: 'EarthQuake',
  //     "pType": this.getSelectedLocTypeUpper(),
  //     startTs,
  //     endTs
  //   };
  //   this.getEarthquakeZoneData();
  //   if (this.earthquakeSub) {
  //     this.earthquakeSub.unsubscribe();
  //     this.earthquakeSub = null;
  //     // console.log('[Earthquake] Previous request cancelled — new request starting');
  //   }
  //   this.earthquakeSub = this.nhipDataSrv.getEarthquakeHazardData(postData).subscribe(res => {
  //     this.earthquakeData = (res && res.earthquakes) ? res.earthquakes : [];
  //     this.earthquakeCount = (res && !isNullOrUndefined(res.count)) ? res.count : this.earthquakeData.length;

  //     const earthquakeItem = this.hazardsConfig.items.find(i => i.label === 'Earthquakes');
  //     if (earthquakeItem) {
  //       earthquakeItem.count = this.earthquakeCount;
  //     }

  //     this.hazardsConfig.subtitle = `(${this.selectedTimeRange})`;

  //     this.calculateEarthquakeStats();
  //     this.groupEarthquakesByYear();

  //     this.earthquakeDataForPdf = []
  //     if (this.earthquakeData.length > 0) {
  //       const highestEarthquake = this.getHighestMagnitude(this.earthquakeData);
  //       this.earthquakeDataForPdf.push(this.earthquakeData[0])
  //       this.earthquakeDataForPdf.push(highestEarthquake)
  //     }
  //   });
  // }
  getEarthquakeData() {
    if (!this.getSelectedLocUUID()) {
      return;
    }
    const range = this.getEarthquakeEpochRange();
    const postData = {
      pUUID: this.getSelectedLocUUID(),
      hazardType: 'EarthQuake',
      pType: this.getSelectedLocTypeUpper(),
      startTs: range.startTs,
      endTs: range.endTs
    };
    this.getEarthquakeZoneData();
    if (this.earthquakeSub) {
      this.earthquakeSub.unsubscribe();
      this.earthquakeSub = null;
      // console.log('[Earthquake] Previous request cancelled — new request starting');
    }
    this.earthquakeSub = this.nhipDataSrv.getEarthquakeHazardData(postData).subscribe(res => {
        this.earthquakeData = (res && res.earthquakes) ? res.earthquakes.sort((a, b) => b.timeEpoch - a.timeEpoch) : [];
      this.earthquakeCount =(res && !isNullOrUndefined(res.count)) ? res.count: this.earthquakeData.length;

      const earthquakeItem = this.hazardsConfig.items.find(i => i.label === 'Earthquakes');
      if (earthquakeItem) {
        earthquakeItem.count = this.earthquakeCount;
      }

      this.hazardsConfig.subtitle = '(' + this.selectedTimeRange + ')';

      this.calculateEarthquakeStats();
      this.groupEarthquakesByYear();
        this.earthquakeDataForPdf = [];
        if (this.earthquakeData.length > 0) {

          const highestEarthquake =
            this.getHighestMagnitude(this.earthquakeData);

          this.earthquakeDataForPdf.push(this.earthquakeData[0]);

          if (highestEarthquake) {
            this.earthquakeDataForPdf.push(highestEarthquake);
          }
        }
        this.earthquakeTableConfiguration = { ...EarthquakeColumnConfig };

        this.earthquakeTableData = this.earthquakeData.map(eq => ({
          type: this.formatMagnitude(eq.magnitude) + ' M',
          depth: (eq.depth !== null && eq.depth !== undefined)
            ? eq.depth
            : '-',
          place: (eq.place !== null && eq.place !== undefined)
            ? eq.place
            : '-',
          date: this.formatDate(eq.timeEpoch)
        }));

      }, error => {

        console.error('Earthquake API error:', error);

        this.earthquakeData = [];
        this.earthquakeTableData = [];
        this.earthquakeCount = 0;

        const earthquakeItem = this.hazardsConfig.items
          .find(i => i.label === 'Earthquakes');

        if (earthquakeItem) {
          earthquakeItem.count = 0;
        }

      });
  }



  getEarthquakeZoneData() {
    const postData = {
      "pUUID": this.getSelectedLocUUID(),
      "pType": this.getSelectedLocTypeUpper(),
      "hazardType": "EarthQuake"
    };

    this.seismicConfig.zone = 'Loading...';
    this.seismicConfig.risk = '';
    this.seismicConfig.riskClass = '';

    if (this.earthquakeZoneSub) {
      this.earthquakeZoneSub.unsubscribe();
    }

    this.earthquakeZoneSub = this.nhipDataSrv.getEarthquakeZonePercentage(postData).subscribe(res => {
      // console.log(res, " getEarthquakeZoneData getEarthquakeZonePercentage");

      if (!res || !res.zones || res.zones.length === 0) {
        this.seismicZones = [];
        this.zonePercentage = 0;
        this.seismicConfig.zone = '';
        this.seismicConfig.risk = '';
        this.seismicConfig.riskClass = '';
        return;
      }

      // this.seismicZones = res.zones;
      this.seismicZones = res.zones.filter(z => z.percentage > 0);
      const dominantZone = res.zones.reduce((max, z) =>
        z.percentage > max.percentage ? z : max
      );
      this.zonePercentage = dominantZone.percentage;
      this.seismicConfig.zone = 'Zone ' + dominantZone.zone;
      this.seismicConfig.risk = this.getRiskByZone(dominantZone.zone);
      this.seismicConfig.riskClass = this.getRiskClassByZone(dominantZone.zone);
    }, error => {
      console.error('Error fetching earthquake zone data:', error);
      this.seismicZones = [];
    });
  }

  calculateEarthquakeStats() {
    if (this.earthquakeData.length === 0) {
      this.largestMagnitude = 0;
      this.averageDepth = 0;
      this.recentEarthquake = null;
      return;
    }
    const maxMag = Math.max(...this.earthquakeData.map(eq => eq.magnitude || 0));
    this.largestMagnitude = parseFloat(maxMag.toFixed(1));
    const validDepths = this.earthquakeData.filter(eq => eq.depth !== null && eq.depth !== undefined).map(eq => eq.depth);
    if (validDepths.length > 0) {
      const totalDepth = validDepths.reduce((sum, depth) => sum + depth, 0);
      this.averageDepth = parseFloat((totalDepth / validDepths.length).toFixed(2));
    } else {
      this.averageDepth = 0;
    }
    const sortedByTime = [...this.earthquakeData].sort((a, b) => b.timeEpoch - a.timeEpoch);
    this.recentEarthquake = sortedByTime[0];
  }

  getRiskByZone(zone: number): string {
    const riskMap: { [key: number]: string } = {
      1: 'Low Risk',
      2: 'Low Risk',
      3: 'Moderate Risk',
      4: 'High Risk',
      5: 'Very High Risk',
      6: 'Extreme Risk'
    };
    return riskMap[zone] || 'Unknown Risk';
  }

  getRiskClassByZone(zone: number): string {
    const classMap: { [key: number]: string } = {
      1: 'low',
      2: 'low',
      3: 'moderate',
      4: 'high',
      5: 'very-high',
      6: 'extreme'
    };
    return classMap[zone] || 'unknown';
  }

  getYearRange(): { startYear: number, endYear: number } {
    const currentYear = 2026; // Current year
    let startYear: number;
    let endYear: number = currentYear;

    switch (this.selectedTimeRange) {
      case 'Last 10 Years':
        startYear = currentYear - 10; // 2016
        break;
      case 'Last 20 years':
        startYear = currentYear - 20; // 2006
        break;
      case 'All Historical':
        startYear = 1980; // Earliest year
        break;
      default:
        startYear = currentYear - 10;
    }

    // console.log(`Year range for ${this.selectedTimeRange}: ${startYear} - ${endYear}`);
    return { startYear, endYear };
  }

  getSelectedLocUUID(): string {
    if (this.selectedLocType === 'COUNTRY') {
      return this.selectedCountryUUID;
    }
    return this.selectedLocType === 'STATE' ? this.selectedStateUUID : this.selectedDistrictUUID;
  }

  getSelectedLocTypeLower(): string {
    if (this.selectedLocType === 'COUNTRY') {
      return 'country';
    }
    return this.selectedLocType === 'STATE' ? 'state' : 'district';
  }

  getSelectedLocTypeUpper(): string {
    if (this.selectedLocType === 'COUNTRY') {
      return 'COUNTRY';
    }
    return this.selectedLocType === 'STATE' ? 'STATE' : 'DISTRICT';
  }


  filterDataByTimeRange(data: any[]): any[] {
    const { startYear, endYear } = this.getYearRange();

    return data.filter(item => {
      let eventTime = item.eventTime;
      if ((!eventTime || eventTime === 0) && item.startTime) {
        eventTime = new Date(item.startTime).getTime();
      }

      if (eventTime) {
        const eventDate = new Date(eventTime);
        const eventYear = eventDate.getFullYear();

        return eventYear >= startYear && eventYear <= endYear;
      }
      return false;
    });
  }

  getEarthquakeEpochRange() {
    const { startYear, endYear } = this.getYearRange();
    return {
      startTs: new Date(startYear, 0, 1).getTime(),
      endTs: new Date(endYear, 11, 31, 23, 59, 59).getTime()
    };
  }
  toggleAllEarthquakes() {
    this.showAllEarthquakes = !this.showAllEarthquakes;
  }
  formatEpoch(epoch: number): string {
    return new Date(epoch).toLocaleString();
  }
  formatMagnitude(val: number): string {
    return (Math.round(val * 10) / 10).toFixed(1);
  }
  processedCycloneData: any[] = [];
  // calculateCycloneStats() {
  //   this.processedCycloneData = this.processCycloneData(this.cycloneData)
  //     .sort((a, b) => b.endTime - a.endTime);

  //   this.cycloneStats.totalEvents = this.processedCycloneData.length;

  //   const uniqueCyclones = new Set(
  //     this.processedCycloneData.map(c => c.hazardName)
  //   );
  //   this.cycloneStats.uniqueCyclones = uniqueCyclones.size;

  //   this.cycloneStats.recentCyclone = this.processedCycloneData[0] || null;
  //   this.processedCycloneDataForPdf = []
  //   if (this.processedCycloneData.length > 0) {
  //     let higherGradeCycloneData = this.getHighestGradeObject(this.processedCycloneData)
  //     this.processedCycloneDataForPdf.push(this.processedCycloneData[0])
  //     this.processedCycloneDataForPdf.push(higherGradeCycloneData)
  //   }
  //   this.nhipDataSrv.setCycloneStats(this.cycloneStats);

  // }
  calculateCycloneStats() {
    this.processedCycloneData = this.processCycloneData(this.cycloneData)
      .sort((a, b) => b.endTime - a.endTime);

    this.cycloneStats.totalEvents = this.processedCycloneData.length;

    const uniqueCyclones = new Set(
      this.processedCycloneData.map(c => c.hazardName)
    );
    this.cycloneStats.uniqueCyclones = uniqueCyclones.size;

    this.cycloneStats.recentCyclone =(this.processedCycloneData.length > 0)? this.processedCycloneData[0]: null;
    this.processedCycloneDataForPdf = [];
    if (this.processedCycloneData.length > 0) {
      const highestGradeCyclone = this.getHighestGradeObject(this.processedCycloneData);

      this.processedCycloneDataForPdf.push(this.processedCycloneData[0]);
      if (highestGradeCyclone) { this.processedCycloneDataForPdf.push(highestGradeCyclone);
      }
    }
    this.nhipDataSrv.setCycloneStats(this.cycloneStats);

  }
  processCycloneData(data: any[]): any[] {
    // const filteredData = data.filter(item => item.hazardName !== "--");
    const filteredData = data;
    const groupedByUUID = this.groupBy(filteredData, 'cycloneUUID');
    const processedCyclones: any[] = [];
    Object.keys(groupedByUUID).forEach(uuid => {
      const cycloneEvents = groupedByUUID[uuid];
      if (cycloneEvents.length === 0 || (uuid === "--" && cycloneEvents[0].hazardName === "--")) return;
      // const cycloneName = cycloneEvents[0].hazardName;
      const rawName = cycloneEvents[0].hazardName;
      const cycloneName = (rawName && rawName.trim() !== "--")
        ? rawName
        : "Name Not Available";

      const getEffectiveTime = (event: any) => {
        if (event.eventTime && event.eventTime !== 0) return event.eventTime;
        if (event.startTime) return new Date(event.startTime).getTime();
        return 0;
      };

      const getEffectiveEndTime = (event: any) => {
        if (event.eventTime && event.eventTime !== 0) return event.eventTime;
        if (event.endTime) return new Date(event.endTime).getTime();
        if (event.startTime) return new Date(event.startTime).getTime();
        return 0;
      };

      const sortedEvents = [...cycloneEvents].sort((a, b) => getEffectiveTime(a) - getEffectiveTime(b));
      const startTime = getEffectiveTime(sortedEvents[0]);
      const endTime = getEffectiveEndTime(sortedEvents[sortedEvents.length - 1]);
      const grades = sortedEvents.map(event => event.grade);
      const gradePriority = this.getGradePriority();
      // const highestGrade = grades.reduce((highest, current) => {
      //   return gradePriority[current] > gradePriority[highest] ? current : highest;
      // });
      const highestGrade = grades.reduce((highest, current) => {
        return gradePriority[current] > gradePriority[highest] ? current : highest;
      });

      // if (['L', 'D', 'DD'].includes(highestGrade)) {
      //   return;
      // }

      const description = (() => {
        const eventWithDesc = sortedEvents.find(event =>
          event.description && event.description.trim()
        );
        return eventWithDesc ? eventWithDesc.description : '';
      })();
      const basins = [...new Set(sortedEvents.map(event => event.basin))];
      const basin = basins.join(', ');

      processedCyclones.push({
        hazardName: cycloneName,
        grade: highestGrade,
        basin: basin,
        description: description,
        startTime: startTime,
        endTime: endTime,
        eventTime: endTime,
        cycloneUUID: uuid
      });
    });

    return processedCyclones;
  }

  groupBy(array: any[], property: string): { [key: string]: any[] } {
    return array.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }

  getGradePriority(): { [key: string]: number } {
    return {
      L: 1,
      D: 2,
      DD: 3,
      CS: 4,
      SCS: 5,
      VSCS: 6,
      ESCS: 7,
      ESC: 7,
      SuCS: 8
    };
  }

  toggleAllCyclones() {
    this.showAllCyclones = !this.showAllCyclones;
  }
  formatDateRange(startEpoch: number, endEpoch: number): string {
    const start = this.formatDate(startEpoch);
    const end = this.formatDate(endEpoch);

    if (start === end) {
      return start;
    }
    return `${start} - ${end}`;
  }
  formatDate(epoch: number): string {
    const d = new Date(epoch);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }
  getCycloneGradeColor(grade: string): string {
    return this.cycloneGradeColors[grade] || '#000000';
  }

  groupEarthquakesByYear() {
    const sorted = [...this.earthquakeData].sort(
      (a, b) => b.timeEpoch - a.timeEpoch
    );

    const groups: { [year: number]: any[] } = {};

    sorted.forEach(eq => {
      const year = new Date(eq.timeEpoch).getFullYear();
      if (!groups[year]) {
        groups[year] = [];
      }
      groups[year].push(eq);
    });

    this.groupedEarthquakes = Object.keys(groups)
      .map(year => ({
        year: Number(year),
        data: groups[Number(year)]
      }))
      .sort((a, b) => b.year - a.year);
  }
  get locationLevelText(): string {
    if (this.selectedLocType === 'COUNTRY') return 'Country';
    return this.selectedLocType === 'STATE' ? 'State' : 'District';
  }



  showPointHazardInfo(lat: number, lng: number, data: any) {

    this.isLoadingPointData = false;
    this.isPointQuery = true;
    this.showAlertInfo = true;

    this.selectedLat = lat;
    this.selectedLng = lng;
    this.pointHazardData = data;

    this.headerConfig.title = 'Point Hazard Query';
    this.headerConfig.location = 'Selected Location';
    this.headerConfig.coords =
      `${lat.toFixed(4)}° N, ${lng.toFixed(4)}° E`;
    if (!this.gisMapComp.dataTabToggleVal) {
      this.gisMapComp.dataTabToggle();
    }

    this.selectedLocType = '';
    this.selectedStateUUID = '';
    this.selectedDistrictUUID = '';

    this.isLoadingPointLocation = true;
    this.isLoadingFacilities = true;
    this.nhipDataSrv.getLocationByPoint({
      latitude: lat,
      longitude: lng
    }).subscribe(res => {
      this.isLoadingPointLocation = false;

      if (res && res.Location) {
        this.pointLocationInfo = {
          stateName: res.Location.stateName,
          districtName: res.Location.districtName,
          blockName: res.Location.blockName
        };
      } else {
        this.pointLocationInfo = null;
      }

    }, error => {
      console.error('Error fetching point location:', error);
      this.isLoadingPointLocation = false;
      this.pointLocationInfo = null;
    });
    this.nhipMapSrv.getNearestFacilities({
      latitude: lat,
      longitude: lng
    }).subscribe(res => {
      this.isLoadingFacilities = false;

      if (!isNullOrUndefined(res) && !isEmptyObject(res)) {
        this.setFacilities(res)
      } else {
        this.facilities = []
      }

    }, error => {
      console.error('Error fetching nearest facilities:', error);
      this.isLoadingFacilities = false;
      this.facilities = []
    });


    this.processPointHazardData(data);
  }

  setFacilities(response: any) {

    const facilityConfig = [
      {
        key: 'nearestSchool',
        title: '🏫 Nearest School',
        label: 'Nearest School'
      },
      {
        key: 'nearestHealthcare',
        title: '🏥 Nearest Healthcare',
        label: 'Nearest Healthcare'
      },
      {
        key: 'nearestAirport',
        title: '✈️ Nearest Major Airport',
        label: 'Nearest Major Airport'
      },
      {
        key: 'nearestRailway',
        title: '🚆 Nearest Railway',
        label: 'Nearest Railway'
      },
      {
        key: 'nearestNH',
        title: '🛣️ Nearest National Highway',
        label: 'Nearest National Highway'
      }
    ];

    this.facilities = facilityConfig
      .filter(f => response[f.key]) // only include if exists
      .map(f => {

        const data = response[f.key];

        return {
          key: f.key,
          title: f.title,
          label: f.label,
          name: data.name,
          distanceKm: data.distanceKm
        };

      });

  }



  showPointHazardError(lat: number, lng: number) {
    this.isLoadingPointData = false;
    this.isPointQuery = true;
    this.showAlertInfo = true;

    this.selectedLat = lat;
    this.selectedLng = lng;

    this.headerConfig.title = 'Point Hazard Query';
    this.headerConfig.location = `${lat.toFixed(4)}° N, ${lng.toFixed(4)}° E`;
    this.headerConfig.coords = `${lat.toFixed(4)}°, ${lng.toFixed(4)}°`;

    this.pointHazardData = null;
    this.nearestEarthquakePoint = null;
    this.nearestCyclone = null;
  }

  processPointHazardData(data: any) {
    if (!data) return;

    if (data.zones) {
      this.pointEarthquakeZone = data.zones.earthquake || 0;
      this.pointWindZone = data.zones.wind || 0;

      this.seismicConfig.zone = `Zone ${this.pointEarthquakeZone}`;
      this.seismicConfig.risk = this.getRiskByZone(this.pointEarthquakeZone);
      this.seismicConfig.riskClass = this.getRiskClassByZone(this.pointEarthquakeZone);

      this.cycloneSeismicConfig.zone = `Zone ${this.pointWindZone}`;
      this.cycloneSeismicConfig.risk = this.getCycloneRiskByZone(this.pointWindZone);
      this.cycloneSeismicConfig.riskClass = this.getCycloneRiskClassByZone(this.pointWindZone);
    }

    if (data.hazards && data.hazards.earthquake) {
      this.nearestEarthquakePoint = data.hazards.earthquake.nearestEarthquakePoint;
      this.nearestFaultLine = data.hazards.earthquake.nearestFaultLine;

      if (this.nearestFaultLine) {
        this.faultConfig = {
          title: 'Nearest Fault Line',
          name: this.nearestFaultLine.faultName || 'Unknown',
          distance: this.nearestFaultLine.distanceKm ?
            `${this.nearestFaultLine.distanceKm.toFixed(1)} km away` : '',
          type: this.getFaultType(this.nearestFaultLine.faultName),
          length: this.getFaultLength(this.nearestFaultLine.faultName),
          lastEvent: '',
          note: `This fault line is ${this.nearestFaultLine.distanceKm ?
            this.nearestFaultLine.distanceKm.toFixed(1) : 'an unknown'} km from the clicked point.`
        };
      }
    }

    if (data.hazards && data.hazards.cyclone) {
      this.nearestCyclone = data.hazards.cyclone;
    }

    this.earthquakeData = [];
    this.cycloneData = [];
    this.faultLines = [];
    this.sortedValidFaultLines = [];
    this.nullFaultLines = [];
    this.faultLineCount = this.nearestFaultLine ? 1 : 0;
    this.seismicZones = [];
    this.cycloneSeismicZones = [];

    const earthquakeItem = this.hazardsConfig.items.find(i => i.label === 'Earthquakes');
    if (earthquakeItem) {
      earthquakeItem.count = this.nearestEarthquakePoint ? 1 : 0;
    }

    const cycloneItem = this.hazardsConfig.items.find(i => i.label === 'Cyclones');
    if (cycloneItem) {
      cycloneItem.count = this.nearestCyclone ? 1 : 0;
    }
  }
  getCycloneGradeWiseData() {

    if (!this.getSelectedLocUUID()) return;

    const { startYear, endYear } = this.getYearRange();

    const postData = {
      pEUUID: '',
      pUUID: this.getSelectedLocUUID(),
      startTs: startYear.toString(),
      endTs: endYear.toString(),
      hazardType: 'CYCLONE',
      locType: this.getSelectedLocTypeLower()
    };

    if (this.cycloneGradeSub) {
      this.cycloneGradeSub.unsubscribe();
      this.cycloneGradeSub = null;
    }
    this.cycloneGradeSub = this.nhipDataSrv.getCycloneGradeWiseData(postData)
      .subscribe((res: any[]) => {
        // console.log(res, "response getCycloneGradeWiseData");

        this.cycloneGradeWiseData = Array.isArray(res) ? res : [];

        this.mergeCycloneGrades();

      }, error => {
        console.error('Error fetching cyclone grade wise data:', error);
        this.cycloneGradeWiseData = [];
      });
  }

  cycloneGradeWiseData: any[] = [];

  // mergeCycloneGrades() {

  //   if (!this.processedCycloneData.length) return;

  //   this.processedCycloneData = this.processedCycloneData.map(cyclone => {

  //     const gradeData = this.cycloneGradeWiseData.find(g =>
  //       g.cycl_uuid === cyclone.cycloneUUID
  //     );

  //     const maxGrade = gradeData
  //       ? gradeData.maxGrade
  //       : cyclone.grade;

  //     return {
  //       ...cyclone,
  //       maxGradeFromAPI: maxGrade
  //     };

  //   });

  //   this.processedCycloneData = this.processedCycloneData.filter(c =>
  //     !['L', 'D', 'DD'].includes(c.maxGradeFromAPI)
  //   );

  //   this.cycloneStats.totalEvents = this.processedCycloneData.length;
  //   // ✅ UPDATE HAZARDS SECTION HERE (AFTER FILTER)
  //   const cycloneItem = this.hazardsConfig.items.find(i => i.label === 'Cyclones');
  //   if (cycloneItem) {
  //     cycloneItem.count = this.cycloneStats.totalEvents;
  //   }
  // }
  mergeCycloneGrades() {

    if (!this.processedCycloneData.length) return;

    this.processedCycloneData = this.processedCycloneData.map(cyclone => {

      const gradeData = this.cycloneGradeWiseData.find(g =>
        g.cycl_uuid === cyclone.cycloneUUID
      );

      const finalGrade = gradeData && gradeData.maxGrade
        ? gradeData.maxGrade
        : cyclone.grade;

      return {
        ...cyclone,
        finalGrade: (finalGrade && typeof finalGrade === 'string')? finalGrade.toUpperCase(): finalGrade
      };

    });

    this.processedCycloneData = this.processedCycloneData.filter(c =>
      !['L', 'D', 'DD'].includes(c.finalGrade)
    );

    this.cycloneStats.totalEvents = this.processedCycloneData.length;

    const cycloneItem = this.hazardsConfig.items.find(i => i.label === 'Cyclones');
    if (cycloneItem) {
      cycloneItem.count = this.cycloneStats.totalEvents;
    }
    this.cycloneTableConfiguration = { ...CycloneColumnConfig };

    this.cycloneTableData = this.processedCycloneData.map(c => {

      const cycloneName =
        (c.hazardName && c.hazardName !== '')
          ? c.hazardName
          : 'Name Not Available';

      return {

        // hazardName: `${cycloneName}<br><span style="color:'${this.cycloneGradeColors[c.finalGrade]}'">(${c.finalGrade})</span>`,//cycloneName + ' <br> <b>(' + c.finalGrade + ')</b>',
        hazardName: `${cycloneName} (${c.finalGrade})`,

        intensity:
          this.cycloneIntensityMapping[c.grade]
            ? this.cycloneIntensityMapping[c.grade]
            : '-',

        basin:
          (c.basin && c.basin !== '')
            ? c.basin.toUpperCase()
            : '-',

        description:
          (c.description && c.description !== '')
            ? c.description
            : '-',

        date:
          this.formatDateRange(c.startTime, c.endTime)

      };

    });

  }
  showAllFaultLines: boolean = false;
  toggleAllFaultLines() {
    this.showAllFaultLines = !this.showAllFaultLines;
  }




  async downloadPdf() {

    // this.mapImage = await this.gisMapComp.downloadImage('png')
    this.mapImage = await this.getMapImage()
    // this.mapImage = await this.captureLeafletCanvas()
    // this.mapImage = this.gisMapComp.mapImage
    // console.log("mapimage::", this.mapImage);

    if (!this.container) {
      console.error('Container not found');
      return;
    }

    this.container.clear();

    // 🔥 1️⃣ Resolve factory
    const factory = this.resolver.resolveComponentFactory(NhipHomePdfComponent);

    // 🔥 2️⃣ Create component
    const componentRef: ComponentRef<NhipHomePdfComponent> =
      this.container.createComponent(factory);

    // 🔥 3️⃣ Pass inputs
    // this.mapImage = this.captureLeafletCanvas();
    componentRef.instance.infoComp = this;
    // componentRef.instance.processedCycloneDataForPdf = this.processedCycloneDataForPdf;
    // componentRef.instance.mapImage = this.mapImage;

    componentRef.changeDetectorRef.detectChanges();

    // Move the report off-screen instead of hiding it (display:none/visibility:hidden
    // would make it 0-size or unpainted, so html2canvas would capture a blank/zero
    // canvas and the PDF generation would silently fail). The width is pinned to
    // A4 at 96dpi (794px) to match the .pdf-wrapper page size, so the capture has
    // A4 proportions and fills the PDF page.
    const hostElement: HTMLElement = componentRef.location.nativeElement;
    hostElement.style.display = 'block';
    hostElement.style.position = 'fixed';
    hostElement.style.top = '0';
    hostElement.style.left = '-10000px';
    hostElement.style.width = '794px';
    hostElement.style.zIndex = '-1';
    hostElement.style.pointerEvents = 'none';

    setTimeout(() => {
      const element = componentRef.location.nativeElement;

      html2canvas(element, {
        scale: 2,
        useCORS: true
      }).then(canvas => {

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');

        // Scale the whole report to fit within one A4 page (instead of a fixed
        // 210mm width, which let tall reports overflow past 297mm and get cut off).
        const pageWidth = 210;
        const pageHeight = 297;
        const scale = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
        const renderWidth = canvas.width * scale;
        const renderHeight = canvas.height * scale;
        const marginX = (pageWidth - renderWidth) / 2;
        const marginY = (pageHeight - renderHeight) / 2;

        pdf.addImage(imgData, 'PNG', marginX, marginY, renderWidth, renderHeight);
        pdf.save('NHIP Report.pdf');
      }).catch(error => {
        console.error('Error generating NHIP PDF report:', error);
      }).finally(() => {
        componentRef.destroy();
        this.gisMapComp.showMapThrobber = false;
      });
    }, 1000);
  }

  getMapImage() {
    return new Promise((resolve, reject) => {
      this.gisMapComp.showMapThrobber = true
      // const map = this.gisMapComp.map
      // map.invalidateSize()
      const mapNode = document.getElementById("map-nhip");
      this.waitForTilesToLoad(mapNode).then(() => {
        html2canvas(mapNode, {
          useCORS: true,
          // Exclude the on-map legend widget (L.Control.HtmlLegendForVisibility,
          // container class 'leaflet-legend') from the exported map image.
          ignoreElements: (element: HTMLElement) =>
            !!(element.classList && element.classList.contains('leaflet-legend'))
        }).then(function (canvas) {
          // var link = document.createElement("a");
          // link.download = "leaflet-map.png";
          // link.href = canvas.toDataURL();
          // link.click();
          const base64Image = canvas.toDataURL("image/png");
          // this.mapImage = base64Image
          resolve(base64Image)
        }).catch(reject);
      });
    })
  }

  // Base tiles, WMS overlays (typically the slowest) and GeoJSON layers all load
  // asynchronously after a location/hazard change. Without this, html2canvas can
  // fire mid-load and capture blank/partial layers into the exported PDF.
  // maxWaitMs bounds it so one stuck tile request can't hang the download.
  waitForTilesToLoad(node: HTMLElement, maxWaitMs: number = 5000): Promise<void> {
    return new Promise((resolve) => {
      const start = Date.now();
      const check = () => {
        const stillLoading = node && node.querySelectorAll('.leaflet-tile-loading').length > 0;
        if (!stillLoading || Date.now() - start > maxWaitMs) {
          resolve();
        } else {
          setTimeout(check, 200);
        }
      };
      check();
    });
  }

  getHighestGradeObject(list: any[]) {
    const gradePriority = [
      'SuCS',
      'ESCS',
      'VSCS',
      'SCS',
      'CS',
      'DD',
      'D',
      'L'
    ];
    if (!list || !list.length) return null;

    return list
      .filter(item => gradePriority.includes(item.grade))
      .sort(
        (a, b) =>
          gradePriority.indexOf(a.grade) - gradePriority.indexOf(b.grade)
      )[0];
  }

  getHighestMagnitude(list: any[]) {
    if (!list || !list.length) return null;

    return list.reduce((max, current) =>
      current.magnitude > max.magnitude ? current : max
    );
  }
  formatWindSpeed(windSpeed: any): string {
    if (!windSpeed) return '';

    let value: number;

    if (Array.isArray(windSpeed)) {
      value = windSpeed[0];
    } else if (typeof windSpeed === 'string') {
      const cleaned = windSpeed.replace('[', '').replace(']', '').split(',');
      value = parseFloat(cleaned[0].trim());
    } else {
      value = windSpeed;
    }

    if (isNaN(value)) return '';

    const kmph = value * 1.852;

    return `${value} kt (${kmph.toFixed(1)} km/h)`;
  }

splitCycloneName(value: any): { name: string, grade: string | null } {

  if (!value) {
    return { name: '', grade: null };
  }

  const stringValue = Array.isArray(value) ? value[0] : String(value);

  const match = stringValue.match(/\((.*?)\)/);

  if (!match || !match[1]) {
    return { name: stringValue, grade: null };
  }

  const grade = match[1].toUpperCase();
  const name = stringValue.replace(/\((.*?)\)/, '').trim();

  return { name, grade };
}

}
